import { gql } from 'apollo-angular';



export const GET_ALL_INVOICES_WITH_PAGINATION = gql`
  query findAllInvoicesWithPagination($input: InvoicePaginationInput) {
    findAllInvoicesWithPagination(input: $input) {
      invoices {
        id
        invoiceNo
        subTotal
        totalAmount
        balance
        invoiceStatus
        paymentStatus
        orderData {
          orderCode
        }
        customerId
        customerData {
          firstName
          lastName
        }
        invoiceDate
        dueDate
        paidDate
      }
      total
      limit
    }
  }
`;

export const GET_ALL_INVOICES = gql`
  query invoices(
    $search: String
    $skip: Int
    $limit: Int
    $startDate: DateTime
    $endDate: DateTime
  ) {
    invoices(
      search: $search
      skip: $skip
      limit: $limit
      startDate: $startDate
      endDate: $endDate
    ) {
      invoices {
        id
        invoiceNo
        subTotal
        totalAmount
        balance
        invoiceStatus
        orderData {
          orderCode
        }
        customerId
        customerData {
          firstName
          lastName
        }
        invoiceDate
        dueDate
        paidDate
      }
      total
      limit
    }
  }
`;

export const LIST_CUSTOMERS = gql`
  query customers($search: String) {
    customers(search: $search) {
      id
      firstName
      lastName
    }
  }
`;

export const LIST_ORDERS = gql`
  query orders($search: String, $customerId: Int, $isRefund: Boolean) {
    orders(search: $search, customerId: $customerId, isRefund: $isRefund) {
      id
      orderCode
    }
  }
`;

export const LIST_INVOICE_BY_ID = gql`
  query invoice($id: Int!) {
    invoice(id: $id) {
      id
      invoiceNo
      subTotal
      discount
      tax
      totalAmount
      balance
      invoiceStatus
      orderId
      branchId
      customerId
      customerData {
        id
        firstName
        lastName
        email
        phoneNumber
        address
        city
        state
        country
        zipCode
      }
      orderData {
        orderCode
      }
      journalData {
        id
        journalNo

        postedAt
        journalEntries {
          id
          accountData {
            id
            accountName
          }
          description
          debit
          credit
        }
      }
      invoiceDate
      dueDate
      paidDate
      invoiceUrl
      IsApproved
      approvedOrRejectedBy
      
      invoiceItems {
        id
        invoiceId
        itemName
        description
        quantity
        rate
        tax
        subTotal
        totalAmount
      }
    }
  }
`;
